export default "__VITE_ASSET__C9zZBqno__"